import { render, staticRenderFns } from "./imgText.vue?vue&type=template&id=03cea265&scoped=true&"
import script from "./imgText.vue?vue&type=script&lang=js&"
export * from "./imgText.vue?vue&type=script&lang=js&"
import style0 from "./imgText.vue?vue&type=style&index=0&id=03cea265&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cea265",
  null
  
)

export default component.exports